<template lang="html">
  <v-app-bar app flat fixed :class="[{ 'navbar-home': $route.name === 'home' }]">
    <v-container fluid class="pa-0 fill-height">
      <v-row class="ma-0 fill-height">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0 fill-height">
          <div class="d-flex fill-height align-center">
            <v-app-bar-nav-icon v-if="this.$store.state.selected_type != 'dine_in_qr'" @click="ShowMenu" />
            <div v-if="$route.name !== 'home'" class="__link-logo" @click="goBack">
              <template v-if="this.$store.state.selected_store">
                <img :src="this.$store.state.selected_store.logo" alt="Logo" class="img-logo">
              </template>
            </div>
            <v-spacer />
            <template v-if="hasRemark.indexOf(this.$route.name) !== -1">
              <template v-if="this.$store.state.selected_type == 'RESERVATION'">
                <div class="img-icon__header">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" class="__img-icon">
                    <defs />
                    <g transform="translate(0 -5.91)">
                      <path class="a" d="M4.548,5.91a.88.88,0,0,0-.5.149l-3.7,3.2A.8.8,0,0,0,0,9.909v1.6a.827.827,0,0,0,.846.8v8.8a.824.824,0,0,0,.846.8h.846a.824.824,0,0,0,.846-.8v-8.8H18.617v8.8a.824.824,0,0,0,.846.8h.846a.824.824,0,0,0,.846-.8v-8.8a.827.827,0,0,0,.846-.8v-1.6a.947.947,0,0,0-.45-.7L17.956,6.059a.88.88,0,0,0-.5-.149Zm-.315,7.2v4a.847.847,0,0,0,1.692,0v-4Zm11.844,0v4a.849.849,0,0,0,1.695,0v-4Z" />
                    </g>
                  </svg>
                </div>
                <span class="primary--text"><b>Reservation</b></span>
              </template>
              <template v-else-if="this.$store.state.selected_type == 'OL-TAKE-AWAY'">
                <div class="img-icon__header">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="__img-icon">
                    <defs />
                    <g transform="translate(-1.984 -1.487)">
                      <path class="a" d="M5.011,1.488A2.05,2.05,0,0,0,2.9,2.709L2,5.916a.442.442,0,0,0,.176.48.482.482,0,0,0,.529.029L4.767,5.243,5.933,6.356a.5.5,0,0,0,.563.075L8.8,5.232,9.98,6.356a.5.5,0,0,0,.338.132.47.47,0,0,0,.229-.057l2.306-1.2L14.03,6.356a.5.5,0,0,0,.446.118.462.462,0,0,0,.341-.3l1.549-4.356a2.137,2.137,0,0,1,.158-.333Zm13.144,0a.949.949,0,0,0-.885.626L15.721,6.464a1.417,1.417,0,0,1-1.155.92,1.539,1.539,0,0,1-1.256-.43l-.626-.6L11,7.23A1.483,1.483,0,0,1,9.308,7l-.671-.641L6.953,7.23A1.478,1.478,0,0,1,5.258,7l-.638-.609-.63.362L2.014,10.63a.4.4,0,0,0-.03.133v10.27a.466.466,0,0,0,.476.455H16.745V10.58a.453.453,0,0,1,.049-.2L19.126,5.8V2.448a.957.957,0,0,0-.791-.949A1.014,1.014,0,0,0,18.155,1.488Zm1.688,5L17.727,10.63a.4.4,0,0,0-.03.133V21.487h3.81a.466.466,0,0,0,.476-.455V10.8a.421.421,0,0,0-.049-.2ZM5.794,13.308h7.144V17.85H5.794Z" transform="translate(0 0)" />
                    </g>
                  </svg>
                </div>
                <span class="primary--text"><b>Take</b> Away</span>
              </template>
              <template v-else-if="this.$store.state.selected_type == 'DELIVERY'">
                <div class="d-flex align-center text-right pl-8">
                  <div v-if="this.$route.name === 'checkout'" class="d-flex flex-column mr-3">
                    <span class="primary--text line-height-regular">
                      <b>Delivery</b>
                    </span>
                  </div>
                  <div v-else class="d-flex flex-column mr-3">
                    <span class="primary--text line-height-regular">
                      <b>Delivery to</b>
                    </span>
                    <div class="d-flex align-center soft-black--text line-height-regular" @click="goSearchMaps()">
                      <v-icon>
                        mdi-chevron-down
                      </v-icon>
                      <span class="one-line--text font-weight-bold">
                        {{ getAddress }}
                      </span>
                    </div>
                  </div>
                  <div class="img-icon__header mr-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" class="__img-icon">
                      <defs />
                      <g transform="translate(0.011 -4.113)">
                        <path class="a" d="M2.2,4.113A1.493,1.493,0,0,0,.733,5.637V16.3a.74.74,0,0,0-.647.376.817.817,0,0,0,0,.771.74.74,0,0,0,.647.376H2.968a2.607,2.607,0,0,0,2.527,2.287,2.607,2.607,0,0,0,2.527-2.287h6.668a2.541,2.541,0,0,0,5.057,0h1.5a.73.73,0,0,0,.644-.376.8.8,0,0,0,0-.771.73.73,0,0,0-.644-.376V12.492h-4.4V9.444a.749.749,0,0,1,.734-.76h2.1l-.251-.6a1.466,1.466,0,0,0-1.343-.923h-4.9V5.637a1.493,1.493,0,0,0-1.465-1.524ZM6.594,6.4a3.737,3.737,0,0,1,3.661,3.811,3.736,3.736,0,0,1-3.661,3.807,3.737,3.737,0,0,1-3.665-3.807A3.738,3.738,0,0,1,6.594,6.4Zm-.014.749a.755.755,0,0,0-.72.774v2.287a.758.758,0,0,0,.407.68l1.462.764a.721.721,0,0,0,.985-.34.779.779,0,0,0-.327-1.024l-1.061-.55V7.921a.782.782,0,0,0-.212-.55A.747.747,0,0,0,6.58,7.146ZM5.494,16.3a1.145,1.145,0,1,1-1.1,1.144A1.111,1.111,0,0,1,5.494,16.3Zm11.722,0a1.145,1.145,0,1,1-1.1,1.144A1.111,1.111,0,0,1,17.216,16.3Z" transform="translate(0)" />
                      </g>
                    </svg>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  data() {
    return {
      options: {
        zoomControl: false,
        fullscreenControl: false
      },
      data_location: {
        address: '',
        postal_code: '',
        city: '',
        state: '',
        country: ''
      },
      menu: {
        show: false,
        permanent: true
      },
      hasRemark: [
        'listoutlets',
        'reservation',
        'reserve_time',
        'reservation_menu',
        'reservation_menu_group',
        'take_away',
        'take_time',
        'take_away_menu',
        'take_away_menu_group',
        'delivery',
        'delivery_menu',
        'delivery_menu_group',
        'delivery_method',
        'delivery_time',
        'checkout',
        'maps_location'
      ],
      dataCheckoutDelivery: {
        shipping_address: '',
        shipping_delivery_type: 1,
        shipping_time: '',
        shipping_radius: 0,
        shipping_lat: 0,
        shipping_lon: 0,
        item: []
      }
    }
  },
  computed: {
    getAddress() {
      if (this.$store.state.data_cart_delivery) {
        return this.$store.state.data_cart_delivery.shipping_address
      } else {
        return this.dataCheckoutDelivery.shipping_address
      }
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))) this.dataCheckoutDelivery = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))
  },
  methods: {
    ShowMenu() {
      this.menu.show = !this.menu.show
      this.$root.$emit('ShowMenu', this.menu)
    },
    goSearchMaps() {
      this.$router.push({ name: 'search_map' }).catch(() => {})
    },
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    }
  }
}
</script>
